"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef } from "react";
import { AnimatePresence, LazyMotion, domAnimation, m } from "framer-motion";
import { createPortal } from "react-dom";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import MemesArtSubmissionContainer from "./submission/MemesArtSubmissionContainer";
interface MemesArtSubmissionModalProps {
  readonly isOpen: boolean;
  readonly wave: ApiWave;
  readonly onClose: () => void;
  readonly sourceDrop?: ExtendedDrop | undefined;
  readonly onSourceDropDeleted?: (() => void) | undefined;
}
const MemesArtSubmissionModal: React.FC<MemesArtSubmissionModalProps> = t0 => {
  const $ = _c(20);
  const {
    isOpen,
    wave,
    onClose,
    sourceDrop,
    onSourceDropDeleted
  } = t0;
  const modalRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== isOpen || $[1] !== onClose) {
    t1 = () => {
      if (!isOpen) {
        return;
      }
      const handleKeyDown = event => {
        if (event.key === "Escape") {
          onClose();
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    };
    t2 = [isOpen, onClose];
    $[0] = isOpen;
    $[1] = onClose;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!isOpen) {
    return null;
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0
    };
    t4 = {
      opacity: 1
    };
    t5 = {
      opacity: 0
    };
    t6 = {
      duration: 0.2
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t10;
  let t7;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      opacity: 0
    };
    t8 = {
      opacity: 1
    };
    t9 = {
      opacity: 0
    };
    t10 = {
      duration: 0.25,
      ease: "easeOut"
    };
    $[8] = t10;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t10 = $[8];
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== onClose || $[13] !== onSourceDropDeleted || $[14] !== sourceDrop || $[15] !== wave) {
    t11 = <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center md:tw-inset-4"><m.div initial={t7} animate={t8} exit={t9} transition={t10} data-testid="memes-art-submission-modal-panel" className="tw-flex tw-h-[100dvh] tw-max-h-[100dvh] tw-w-full tw-max-w-screen-xl tw-flex-col md:tw-h-full md:tw-max-h-none" ref={modalRef} onClick={_temp}><div className="tw-flex tw-h-full tw-flex-col tw-overflow-hidden"><MemesArtSubmissionContainer onClose={onClose} wave={wave} sourceDrop={sourceDrop} onSourceDropDeleted={onSourceDropDeleted} /></div></m.div></div>;
    $[12] = onClose;
    $[13] = onSourceDropDeleted;
    $[14] = sourceDrop;
    $[15] = wave;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== onClose || $[18] !== t11) {
    t12 = createPortal(<LazyMotion features={domAnimation}><AnimatePresence><m.div initial={t3} animate={t4} exit={t5} transition={t6} className="tailwind-scope tw-fixed tw-inset-0 tw-z-[1000] tw-overflow-hidden tw-bg-gray-600/80 tw-backdrop-blur-sm" onClick={onClose}>{t11}</m.div></AnimatePresence></LazyMotion>, document.body);
    $[17] = onClose;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};
export default MemesArtSubmissionModal;
function _temp(e) {
  e.stopPropagation();
}